(function(angular) {
    'use strict';

    var app = angular.module('asDemandMgr');


    app.filter('tzFromMsMoment', function () {
        return function (ms, format, timeZone) {
            if (ms == null) return '';
            if (ms < 1e12) ms = ms * 1000;
            return moment.tz(Number(ms), timeZone).format(format);
        };
    });

    app.filter('userTimezoneDate', function ($rootScope) {
        return function (ms, format) {
            if (ms == null) return '';
            if (ms < 1e12) ms = ms * 1000;
            return moment.tz(Number(ms), $rootScope.app.getUserTimezone()).format(format);
        };
    });
})(window.angular);
